import React from 'react';
export const CtaSection = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-6 md:px-10 bg-navy text-cream" data-id="element-62">
      <div className="max-w-4xl mx-auto text-center" data-id="element-63">
        <h2 className="text-3xl md:text-4xl font-bold mb-10" data-id="element-64">¿Es para ti?</h2>
        <p className="text-xl mb-6" data-id="element-65">Sí, si eres una mujer que:</p>
        <div className="grid md:grid-cols-2 gap-4 mb-12 text-left max-w-2xl mx-auto" data-id="element-66">
          <div className="flex items-start" data-id="element-67">
            <span className="text-gold font-bold mr-2" data-id="element-68">✓</span>
            <span data-id="element-69">trabaja duro</span>
          </div>
          <div className="flex items-start" data-id="element-70">
            <span className="text-gold font-bold mr-2" data-id="element-71">✓</span>
            <span data-id="element-72">siente que su dinero no rinde</span>
          </div>
          <div className="flex items-start" data-id="element-73">
            <span className="text-gold font-bold mr-2" data-id="element-74">✓</span>
            <span data-id="element-75">ayuda a su familia</span>
          </div>
          <div className="flex items-start" data-id="element-76">
            <span className="text-gold font-bold mr-2" data-id="element-77">✓</span>
            <span data-id="element-78">vive con ansiedad financiera</span>
          </div>
          <div className="flex items-start" data-id="element-79">
            <span className="text-gold font-bold mr-2" data-id="element-80">✓</span>
            <span data-id="element-81">quiere claridad real</span>
          </div>
          <div className="flex items-start" data-id="element-82">
            <span className="text-gold font-bold mr-2" data-id="element-83">✓</span>
            <span data-id="element-84">quiere paz mental</span>
          </div>
          <div className="flex items-start" data-id="element-85">
            <span className="text-gold font-bold mr-2" data-id="element-86">✓</span>
            <span data-id="element-87">quiere avanzar paso a paso</span>
          </div>
          <div className="flex items-start" data-id="element-88">
            <span className="text-gold font-bold mr-2" data-id="element-89">✓</span>
            <span data-id="element-90">quiere dejar de sentirse sola</span>
          </div>
        </div>
        <div className="space-y-3 mb-10" data-id="element-91">
          <p className="text-xl font-semibold" data-id="element-92">
            Elige claridad. Elige control. Elige paz.
          </p>
          <p className="text-2xl font-bold" data-id="element-93">
            Entra ahora a: ¿DÓNDE SE VA MI DINERO?
          </p>
          <p data-id="element-94">Tu nueva tranquilidad empieza en 10 minutos.</p>
        </div>
        <button onClick={scrollToPricing} className="btn-primary text-lg px-10 py-4" data-id="element-95">
          Quiero Empezar Ahora
        </button>
      </div>
    </section>;
};